import { type ComponentType, use } from 'react';

import overlayVideo from '#core/assets/video/agent/1.mp4?url';
import aiVideo from '#core/assets/video/agent/3.mp4?url';
import { ProjectContext } from '#core/contexts/ProjectContext.ts';

import classes from './AtlasAiSpinner.module.css';

export function AtlasAiSpinner() {
  const { config } = use(ProjectContext);
  // The per-project config type narrows the agent to its concrete fields, dropping
  // unset optionals; bind to a shape that surfaces the optional spinner override.
  const agent: { name: string; spinner?: ComponentType } = config.feature.ai.agent;
  const SpinnerComponent = agent.spinner ?? DefaultSpinner;
  return (
    <div className={classes.spinnerContainer}>
      <SpinnerComponent />
    </div>
  );
}

function DefaultSpinner() {
  return (
    <>
      <video autoPlay className={classes.spinner} loop muted playsInline>
        <source src={aiVideo} type="video/mp4" />
      </video>
      <video autoPlay className={classes.spinnerOverlay} loop muted playsInline>
        <source src={overlayVideo} type="video/mp4" />
      </video>
    </>
  );
}
